<template>
  <div class="tabs-box" :class="{ 'tabs-box-en' : lang == 'en' }">
    <ul class="tabs">
      <li class="tabs-item-custom" :class="{active:!(index-tabActive)}" @click="tabClick(item, index, $event)" v-for="(item,index) in tabs" :key="index" :style="{ 'z-index': (99 - index)}">
        <span>{{item[keyProp]}}</span>
      </li>
    </ul>
    <div class="tab-content" :class="{ 'tab-content-padding': needPadding }">
      <slot name="tabContent" />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: "CustomTabs",
    props: {
      // 标签列表
      tabs: {
        type: Array,
        default() {
          return []
        }
      },
      // 标签默认选中值
      defaultActive: {
        type: String | Number,
        default() {
          return 0;
        }
      },
      keyProp: {
        type: String,
        default() {
          return 'label';
        }
      },
      needPadding: {
        type: Boolean,
        default() {
          return true;
        }
      }
    },
    data() {
      return {
      }
    },
    methods: {
      tabClick(tab, index) {
        if (this.tabActive == index) {
          return;
        }
        this.tabActive = index;
        this.$emit('tab-click', { tab, index });
      }
    },
    computed: {
      ...mapGetters(['lang']),
      tabActive() {
        return this.defaultActive;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tabs-box {
    display: flex;
    .tabs {
      display: flex;
      flex-direction: column;
      position: relative;
      width: 120px;
      margin-right: -1px;
      .tabs-item-custom {
        cursor: pointer;
        text-align: center;
        font-size: 12px;
        min-height: 28px;
        color: #656565;
        background-color: #f8f8f8;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-border-radius: 14px 0 0 14px;
        -moz-border-radius: 14px 0 0 14px;
        border-radius: 14px 0 0 14px;
        border: 1px solid #dcdfe6;
        margin-bottom: 10px;
        padding: 0 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        &.active {
          color: #FF6B07;
          background-color: #fff;
          border-right: none;
        }
      }
    }
    .tab-content {
      padding: 0px;
      border: 1px solid #dcdfe6;
      width: calc(100% - 120px);
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      -webkit-border-radius: 0 4px 4px 4px;
      -moz-border-radius: 0 4px 4px 4px;
      border-radius: 0 4px 4px 4px;
      &.tab-content-padding {
        padding: 10px 15px;
      }
    }
  }
</style>
